$('.in-index .products-block').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1439, settings: { slidesToShow: 4, slidesToScroll: 1 }},
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
    { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
    { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, dots:true}},
    { breakpoint: 430,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }}
  ]
});

$('.type-detail .products-block').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  autoplay: false,
  autoplaySpeed: 5000,
  dots: false,
  arrows: true,
  infinite: false,
  adaptiveHeight: false,
  responsive: [
    { breakpoint: 1439, settings: { slidesToShow: 4, slidesToScroll: 1 }},
    { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
    { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
    { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, dots:true}},
    { breakpoint: 430,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, dots:true }}
  ]
});